import Navbar from '../components/Navbar';
import { Leaf, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CGUPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="container-app py-12">
        <Link to="/" className="inline-flex items-center text-sage-600 hover:text-sage-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>
        
        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-soft">
          <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground mb-8">
            Conditions Générales d'Utilisation (CGU)
          </h1>
          
          <p className="text-muted-foreground mb-8">
            Dernière mise à jour : Décembre 2024
          </p>
          
          <div className="prose prose-sage max-w-none">
            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">1. Objet</h2>
            <p className="text-muted-foreground mb-4">
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités 
              et conditions d'utilisation de la plateforme Opora Vie (accessible à l'adresse apora.net), 
              ainsi que les droits et obligations des utilisateurs.
            </p>
            <p className="text-muted-foreground mb-4">
              Opora Vie est une plateforme de mise en relation entre des praticiens du bien-être 
              (ci-après "Praticiens") et des personnes recherchant leurs services (ci-après "Clients").
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">2. Acceptation des CGU</h2>
            <p className="text-muted-foreground mb-4">
              L'utilisation de la plateforme implique l'acceptation pleine et entière des présentes CGU. 
              En créant un compte ou en utilisant nos services, vous reconnaissez avoir lu, compris et 
              accepté ces conditions.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">3. Description des services</h2>
            <p className="text-muted-foreground mb-4">
              Opora Vie propose les services suivants :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Recherche et découverte de praticiens du bien-être</li>
              <li>Prise de rendez-vous en ligne</li>
              <li>Consultations en cabinet ou en visioconférence</li>
              <li>Paiement sécurisé en ligne</li>
              <li>Accès à des ressources et articles sur le bien-être</li>
              <li>Boutique de livres numériques</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">4. Inscription et compte utilisateur</h2>
            <p className="text-muted-foreground mb-4">
              Pour accéder à certains services, les utilisateurs doivent créer un compte en fournissant 
              des informations exactes et à jour. Chaque utilisateur est responsable de la confidentialité 
              de ses identifiants de connexion.
            </p>
            <p className="text-muted-foreground mb-4">
              Les Praticiens doivent fournir des informations professionnelles vérifiables et s'engagent 
              à exercer conformément à la législation en vigueur dans leur pays d'exercice.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">5. Obligations des utilisateurs</h2>
            <p className="text-muted-foreground mb-4">
              Les utilisateurs s'engagent à :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Utiliser la plateforme de manière loyale et respectueuse</li>
              <li>Ne pas publier de contenu illicite, diffamatoire ou trompeur</li>
              <li>Respecter les droits de propriété intellectuelle</li>
              <li>Ne pas tenter d'accéder aux données d'autres utilisateurs</li>
              <li>Signaler tout comportement suspect ou abusif</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">6. Responsabilité</h2>
            <p className="text-muted-foreground mb-4">
              Opora Vie agit en qualité d'intermédiaire technique et ne saurait être tenue responsable 
              des prestations fournies par les Praticiens. La plateforme ne fournit aucun conseil médical 
              et ne se substitue pas à une consultation médicale professionnelle.
            </p>
            <p className="text-muted-foreground mb-4">
              Les Praticiens sont seuls responsables de leurs actes professionnels et doivent disposer 
              des qualifications et assurances requises pour exercer leur activité.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">7. Propriété intellectuelle</h2>
            <p className="text-muted-foreground mb-4">
              L'ensemble des éléments de la plateforme (textes, images, logos, code source) sont protégés 
              par les droits de propriété intellectuelle. Toute reproduction ou utilisation non autorisée 
              est strictement interdite.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">8. Modification des CGU</h2>
            <p className="text-muted-foreground mb-4">
              Opora Vie se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs 
              seront informés de toute modification substantielle. La poursuite de l'utilisation de la 
              plateforme après modification vaut acceptation des nouvelles conditions.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">9. Droit applicable et juridiction</h2>
            <p className="text-muted-foreground mb-4">
              Les présentes CGU sont soumises au droit français. Tout litige relatif à l'interprétation 
              ou à l'exécution des présentes sera soumis aux tribunaux compétents.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">10. Contact</h2>
            <p className="text-muted-foreground mb-4">
              Pour toute question relative aux présentes CGU, vous pouvez nous contacter à l'adresse : 
              <a href="mailto:contact@apora.net" className="text-sage-600 hover:text-sage-700"> contact@apora.net</a>
            </p>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-8 bg-foreground text-white mt-12">
        <div className="container-app text-center">
          <p className="text-sand-300 text-sm">
            © 2024 Opora Vie. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default CGUPage;
